// ---------------------------------------------------------------------------
// Shared active-path matching for the app-shell navigation.
//
// A nav item is active when the current path equals its `path`, or — for
// non-`end` items — when the current path is a *descendant* of `path`. The
// descendant check is boundary-aware (`path + '/'`) so sibling routes that
// merely share a string prefix don't both light up. For example
// `/judge-factory-gen` must NOT activate the `/graders` item.
// ---------------------------------------------------------------------------

export function isNavItemActive(
  selectedPath: string,
  itemPath: string,
  end?: boolean,
): boolean {
  if (selectedPath === itemPath) return true;
  if (end) return false;
  return selectedPath.startsWith(`${itemPath}/`);
}
